// ISO 3166-1 alpha-2 → international dial code. Used by the PhoneInput
// country picker (paired with the flag emoji derived from the ISO code).
// Keep this list in sync with /lib/nationalities.js country codes.
export const DIAL_CODES = [
  ["US","1","United States"],   ["CA","1","Canada"],            ["GB","44","United Kingdom"],
  ["AE","971","United Arab Emirates"], ["SA","966","Saudi Arabia"], ["EG","20","Egypt"],
  ["IN","91","India"],          ["PK","92","Pakistan"],         ["BD","880","Bangladesh"],
  ["LK","94","Sri Lanka"],      ["NP","977","Nepal"],
  ["AU","61","Australia"],      ["NZ","64","New Zealand"],
  ["JP","81","Japan"],          ["KR","82","South Korea"],      ["CN","86","China"],
  ["HK","852","Hong Kong"],     ["TW","886","Taiwan"],          ["SG","65","Singapore"],
  ["MY","60","Malaysia"],       ["TH","66","Thailand"],         ["ID","62","Indonesia"],
  ["PH","63","Philippines"],    ["VN","84","Vietnam"],
  ["FR","33","France"],         ["DE","49","Germany"],          ["IT","39","Italy"],
  ["ES","34","Spain"],          ["PT","351","Portugal"],        ["NL","31","Netherlands"],
  ["BE","32","Belgium"],        ["CH","41","Switzerland"],      ["AT","43","Austria"],
  ["IE","353","Ireland"],       ["DK","45","Denmark"],          ["SE","46","Sweden"],
  ["NO","47","Norway"],         ["FI","358","Finland"],         ["IS","354","Iceland"],
  ["PL","48","Poland"],         ["CZ","420","Czech Republic"],  ["SK","421","Slovakia"],
  ["HU","36","Hungary"],        ["RO","40","Romania"],          ["BG","359","Bulgaria"],
  ["GR","30","Greece"],         ["TR","90","Turkey"],           ["RU","7","Russia"],
  ["UA","380","Ukraine"],       ["BY","375","Belarus"],         ["KZ","7","Kazakhstan"],
  ["IL","972","Israel"],        ["JO","962","Jordan"],          ["LB","961","Lebanon"],
  ["SY","963","Syria"],         ["IQ","964","Iraq"],            ["IR","98","Iran"],
  ["KW","965","Kuwait"],        ["BH","973","Bahrain"],         ["QA","974","Qatar"],
  ["OM","968","Oman"],          ["YE","967","Yemen"],
  ["MA","212","Morocco"],       ["DZ","213","Algeria"],         ["TN","216","Tunisia"],
  ["LY","218","Libya"],         ["SD","249","Sudan"],
  ["ZA","27","South Africa"],   ["NG","234","Nigeria"],         ["KE","254","Kenya"],
  ["GH","233","Ghana"],         ["ET","251","Ethiopia"],        ["TZ","255","Tanzania"],
  ["UG","256","Uganda"],        ["MX","52","Mexico"],           ["BR","55","Brazil"],
  ["AR","54","Argentina"],      ["CL","56","Chile"],            ["CO","57","Colombia"],
  ["PE","51","Peru"],           ["VE","58","Venezuela"],
];

// Convert an ISO alpha-2 country code into the flag emoji that browsers
// render natively (each letter mapped to its Regional Indicator codepoint).
export function flagEmoji(code) {
  if (!code || code.length !== 2) return "";
  const base = 127397; // 0x1F1E6 - "A".charCodeAt(0)
  const a = code.toUpperCase().charCodeAt(0);
  const b = code.toUpperCase().charCodeAt(1);
  return String.fromCodePoint(a + base) + String.fromCodePoint(b + base);
}

// Best-guess at the user's country, used to pre-select the dial-code dropdown.
// Tries: explicit prop  →  saved user profile country  →  browser locale region.
export function detectCountry(fallback = "AE") {
  try {
    const navLang = (typeof navigator !== "undefined" && navigator.language) || "";
    const region = navLang.split("-")[1] || navLang.toUpperCase().slice(0, 2);
    if (region && DIAL_CODES.find(([c]) => c === region.toUpperCase())) return region.toUpperCase();
  } catch { /* SSR-safe noop */ }
  return fallback;
}

export function getDialEntry(code) {
  return DIAL_CODES.find(([c]) => c === (code || "").toUpperCase()) || null;
}
